module.exports = __webpack_public_path__ + "static/media/Shooting Stars.bed25b65.jpg";